module.exports = __webpack_public_path__ + "static/arco-7adc90802e32a73cd970cedebc0f4358.webp";